import { type FC } from 'react'

import { Separator } from '@wartek-id/separator'
import { Text } from '@wartek-id/text-v1'

import { SimpleCard } from 'app/KinerjaPSPegawaiPage/components/SimpleCard'
import {
  PELAKSANAAN_PRAKTIK_KINERJA_PENDAMPINGAN_SUBMITTED_FIELD_TYPES,
  PELAKSANAAN_PRAKTIK_KINERJA_STATE_TITLE,
} from 'app/KinerjaPenilikPegawaiPage/constants/praktikKinerja'
import BlockQuestionAnswerPreview from 'app/KinerjaPenilikPegawaiPage/pages/Pelaksanaan/PraktikKinerja/PendampinganSatuanPendidikan/components/BlockQuestionAnswerPreview'
import { ButtonPelaksanaanAppealRollback } from 'app/KinerjaPenilikPegawaiPage/components/ButtonPelaksanaanAppealRollback'
import useToggleSdkContext from 'utils/useToogleSdk'

import type {
  PraktikKinerjaPendampinganFormValue,
  PraktikKinerjaFormName,
} from 'types/kinerja-penilik-pegawai'
import type { PelaksanaanPraktikKinerjaProps } from 'app/KinerjaPenilikPegawaiPage/hooks/usePelaksanaanPraktikKinerja'

type CardFormPreviewProps = {
  formValues: PelaksanaanPraktikKinerjaProps<
    PraktikKinerjaPendampinganFormValue,
    {}
  >
  formName: PraktikKinerjaFormName
  showAppealButton?: boolean
}

const CardFormPreview: FC<CardFormPreviewProps> = ({
  formValues,
  formName,
  showAppealButton = false,
}) => {
  const toggle = useToggleSdkContext()
  const appealRollbackEnabled =
    toggle?.['kinerja-penilik-pegawai-appeal-rollback-enabled'] || false

  const questionAnswersEntries = Object.entries(
    PELAKSANAAN_PRAKTIK_KINERJA_PENDAMPINGAN_SUBMITTED_FIELD_TYPES
  )

  return (
    <div className="grid grid-cols-12">
      <SimpleCard className="col-start-2 col-span-10 !rounded mb-24">
        {/* Simple Card Header */}
        <div className="flex flex-col gap-1 p-6 border-b rounded-t bg-blue-5 border-b-surface-subdued">
          <Text variant="heading-lg">
            Pengisian{' '}
            {PELAKSANAAN_PRAKTIK_KINERJA_STATE_TITLE?.[formName] ?? ''}
          </Text>
        </div>

        {/* Simple Card Content */}
        <div className="p-6 space-y-6">
          {questionAnswersEntries.map(([fieldType, question], index) => {
            const answer = formValues?.parsedFormValues?.[fieldType] || '-'

            return (
              <>
                <BlockQuestionAnswerPreview
                  key={index}
                  index={index}
                  question={question}
                  answer={answer}
                />
                {index < questionAnswersEntries.length - 1 && (
                  <Separator orientation="horizontal" />
                )}
              </>
            )
          })}

          {appealRollbackEnabled && showAppealButton && (
            <>
              <Separator orientation="horizontal" />
              <div className="flex justify-end">
                <ButtonPelaksanaanAppealRollback formName="pendampingan_sekolah" />
              </div>
            </>
          )}
        </div>
      </SimpleCard>
    </div>
  )
}

export default CardFormPreview
